import { SvgIcon, SvgIconProps } from '../SvgIcon';
import { getColor } from '../utils';

export const SplineChart = ({
  height = 24,
  width = 24,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 64 64" {...props}>
    <path
      fill={getColor(color, isColorInherited)}
      d="M58,16c0-1.1-0.9-2-2-2s-2,0.9-2,2c0,0.5,0.2,0.9,0.5,1.3c-5.3,13.9-9.8,18.5-12.9,19.5C41.2,36.3,40.6,36,40,36c-0.6,0-1.1,0.3-1.5,0.7c-2.1-0.8-3.9-3-5.7-5.3c-2-2.6-4.1-5.2-6.9-6.1c-0.3-0.8-1-1.3-1.9-1.3c-0.8,0-1.6,0.5-1.9,1.3c-4.9,1.3-9.6,8.2-14.5,20.8c-1,0.2-1.7,1-1.7,2c0,1.1,0.9,2,2,2s2-0.9,2-2c0-0.5-0.2-0.9-0.5-1.3c5.3-13.9,9.8-18.5,12.9-19.5c0.4,0.5,0.9,0.8,1.6,0.8c0.6,0,1.1-0.3,1.5-0.7c2.1,0.8,3.9,3,5.7,5.3c2,2.6,4.1,5.2,6.9,6.1c0.3,0.8,1,1.3,1.9,1.3c0.8,0,1.6-0.5,1.9-1.3c4.9-1.3,9.6-8.2,14.5-20.8C57.3,17.8,58,17,58,16z"
    />
  </SvgIcon>
);
